"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Roles = exports.QuestionTypesEnum = exports.Privileges = exports.ClientIntegrationActions = void 0;
/** Possible actions for Client Integrations */
var ClientIntegrationActions;
(function (ClientIntegrationActions) {
    ClientIntegrationActions["Subscribe"] = "SUBSCRIBE";
})(ClientIntegrationActions = exports.ClientIntegrationActions || (exports.ClientIntegrationActions = {}));
var Privileges;
(function (Privileges) {
    Privileges["Api"] = "API";
    Privileges["Developer"] = "DEVELOPER";
    Privileges["OtpUnverified"] = "OTP_UNVERIFIED";
    Privileges["Private"] = "PRIVATE";
    Privileges["Protected"] = "PROTECTED";
    Privileges["Public"] = "PUBLIC";
    Privileges["System"] = "SYSTEM";
})(Privileges = exports.Privileges || (exports.Privileges = {}));
var QuestionTypesEnum;
(function (QuestionTypesEnum) {
    QuestionTypesEnum["Checkbox"] = "CHECKBOX";
    QuestionTypesEnum["Dropdown"] = "DROPDOWN";
    QuestionTypesEnum["Text"] = "TEXT";
    QuestionTypesEnum["YesNoUnknown"] = "YES_NO_UNKNOWN";
    QuestionTypesEnum["YesOrNo"] = "YES_OR_NO";
})(QuestionTypesEnum = exports.QuestionTypesEnum || (exports.QuestionTypesEnum = {}));
var Roles;
(function (Roles) {
    Roles["ClientAdmin"] = "CLIENT_ADMIN";
    Roles["ClientMember"] = "CLIENT_MEMBER";
    Roles["ClientSales"] = "CLIENT_SALES";
    Roles["None"] = "NONE";
    Roles["ResolvexAdmin"] = "RESOLVEX_ADMIN";
    Roles["ResolvexMember"] = "RESOLVEX_MEMBER";
})(Roles = exports.Roles || (exports.Roles = {}));
//# sourceMappingURL=gen-types.js.map